var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageAlerts"}},[(_vm.alertType == 'success')?_c('v-alert',{attrs:{"border":"left","type":"success"}},[_vm._v(_vm._s(_vm.alertMsg)+" ")]):(_vm.alertType == 'error')?_c('v-alert',{attrs:{"border":"left","type":"error"}},[_vm._v(_vm._s(_vm.alertMsg)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }